/* Additional lead and artwork intent only. Ecommerce remains owned by Shopify's Google channel. */
(() => {
  'use strict';
  if (window.__vpGrowthEventsBound) return;
  window.__vpGrowthEventsBound = true;
  const stream = 'G-6XB5CGBDLS';
  const pendingKey = 'vp_quote_pending_v1';
  const products = new Set(['custom-business-cards-standard','yard-signs','vinyl-banner','contractor-full-color-workwear-bundle']);
  const pages = new Set(['contact','custom-printing-dearborn-mi','contractor-yard-signs','contractor-workwear-packages','business-print-bundles-detroit-mi']);
  const parts = location.pathname.split('/').filter(Boolean);
  const product = parts[0] === 'products' && products.has(parts[1]) ? parts[1] : 'other';
  const page = parts[0] === 'pages' && pages.has(parts[1]) ? parts[1] : parts[0] === 'collections' && ['business-cards','bundles'].includes(parts[1]) ? parts[1] : location.pathname === '/' ? 'home' : 'other';
  const safePath = product !== 'other' ? '/products/' + product : page !== 'other' && page !== 'home' ? '/' + parts[0] + '/' + page : '/';
  const debug = new URLSearchParams(location.search).get('vp_measurement_debug') === '1';
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; }
    catch (_) { return false; }
  };
  const status = state => {
    if (debug) document.documentElement.setAttribute('data-vp-measurement-status', JSON.stringify({state,privacy_api_ready:typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function',analytics_allowed:allowed(),google_tag_ready:typeof window.gtag === 'function',stream}));
  };
  function send(name, details) {
    if (!allowed()) { status('consent_blocked'); return false; }
    if (typeof window.gtag !== 'function') { status('existing_tag_unavailable'); return false; }
    window.gtag('event', name, {send_to:stream,page_location:location.origin + safePath,page_referrer:'',page_title:'Varaprint',product_key:product,page_key:page,...details});
    status('event_dispatched');
    return true;
  }
  document.addEventListener('click', event => {
    const el = event.target.closest('a,button');
    if (!el || el.disabled || el.hidden) return;
    const href = el.getAttribute('href') || '';
    if (/^tel:/i.test(href)) send('contact_phone_click',{contact_method:'phone'});
    else if (/^mailto:/i.test(href)) send('contact_email_click',{contact_method:'email'});
    else {
      let action = '';
      if (el.matches('[data-vp-card-edit],[data-vp-sticker-edit],[data-vp-studio-edit]')) action = 'design_online';
      else if (el.matches('[data-vp-card-upload],[data-vp-studio-upload]')) action = 'upload_entry';
      else if (el.matches('[data-vp-card-download],[data-vp-studio-download]')) action = 'template_download';
      else if (el.matches('[data-vp-gallery]')) action = 'template_gallery';
      if (action) send('customization_entry',{tool_action:action});
    }
  },true);
  document.addEventListener('change', event => {
    const el = event.target;
    if (el.matches('input[type="file"][name^="properties["]') && el.files?.length) {
      send('artwork_file_selected',{artwork_action:'file_selected'});
    }
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('form') || !form.querySelector('input[name="form_type"][value="contact"]') || !allowed()) return;
    try { sessionStorage.removeItem(pendingKey); } catch (_) {}
    if (!form.checkValidity()) return;
    const isWorkwear = form.id === 'cw-request-form';
    const reason = form.querySelector('[name="contact[request_type]"]');
    if (!isWorkwear && reason?.value !== 'Custom quote') return;
    try { sessionStorage.setItem(pendingKey,JSON.stringify({path:location.pathname,form_kind:isWorkwear?'workwear_quote':'contact_quote',created:Date.now()})); }
    catch (_) { /* Storage unavailable: do not infer a successful quote from a button click. */ }
  },true);
  function acceptedQuote() {
    status('ready');
    if (!allowed() || !document.querySelector('.vp-form-success,.cw-form-success,[data-vp-quote-accepted]')) return;
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null'); }
    catch (_) { return; }
    if (!pending || pending.path !== location.pathname || !['workwear_quote','contact_quote'].includes(pending.form_kind) || Date.now()-pending.created > 600000 || Date.now()<pending.created) return;
    let attempts = 0;
    const dispatch = () => {
      if (!allowed()) return;
      if (send('quote_submit_success',{form_kind:pending.form_kind})) {
        try { sessionStorage.removeItem(pendingKey); } catch (_) {}
      } else if (++attempts < 10) setTimeout(dispatch,500);
    };
    dispatch();
  }
  function initialize() {
    if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function') acceptedQuote();
    else if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error => {
        if (error) status('privacy_api_unavailable');
        else acceptedQuote();
      });
    } else status('privacy_api_unavailable');
  }
  document.addEventListener('visitorConsentCollected',() => status('consent_updated'));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
})();
